import { useGoogleMap } from "@react-google-maps/api"
import React from "react"
import { LatLng } from "utils/custom.types"
import { CustomButtonProps } from "../Atoms/CustomButton"
import CenterButton from "../Organisms/map/CenterButton"

interface MapCenterButtonProps extends CustomButtonProps {
  /**
   * Return a location for every item
   * i.e returns {lat:12,lng:12} for every iteratable item
   */
  getItemLocation: (item: any) => LatLng | undefined | null
  /**
   * List of items
   */
  items: any[]
}
const MapCenterButton = ({
  items,
  getItemLocation,
  ...otherProps
}: MapCenterButtonProps) => {
  const map = useGoogleMap()

  return (
    <CenterButton
      onClick={e => {
        if (map && items.length > 0) {
          const bounds = new window.google.maps.LatLngBounds()

          items.forEach(l => {
            const location = getItemLocation(l)

            if (location) {
              bounds.extend(location)
            }
          })
          map.fitBounds(bounds)
        }
      }}
      {...otherProps}
    />
  )
}

export default MapCenterButton
